module.exports = __webpack_public_path__ + "static/img/2.7e73b4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/2.jpg
// module id = Z1XC
// module chunks = 0